import $ from 'jquery';
import { Formatter, PaymentCalculatorFactory } from '@dealersites/dealersite-js-core';
import { getTotalIMSTargetedSelected, getCostOfBorrowing } from '../../showroom/showroom-utilities.js'

class PaymentCalculatorForm {

  constructor(formElementId) {


    this.element = document.getElementById(formElementId);
    this.targetIncentives = document.getElementById('targeted-incentives');
    if (!this.element) {
      return;
    }

    this.prefix = '#js-calc-small-';

    this.finance = PaymentCalculatorFactory.createCalculator('finance', {});
    this.lease = PaymentCalculatorFactory.createCalculator('lease', {});

    this.hasFinanceCalculator = true;
    this.hasLeaseCalculator = true;

    this.hasPaymentDropdown = false;

    let financeVariables = $(this.prefix + 'finance-balance-value').data('financeValues');

    this.financeVariables = [];

    if (financeVariables) {
      for (const [key, value] of Object.entries(financeVariables)) {
        this.financeVariables.push(value);
      }
    }

 

    this.leaseVariables = [];

    let leaseVariables = $(this.prefix + 'lease-balance-value').data('leaseValues');

    if (leaseVariables) {
      for (const [key, value] of Object.entries(leaseVariables)) {
        this.leaseVariables.push(value);
      }
    }

    this.includeTax = true;

    this.dropdown = this.element.querySelector(this.prefix + 'payment-dropdown');

    if (this.dropdown) {
      this.hasPaymentDropdown = true;
    }

    $(`#${formElementId}`).find('.js-targeted-incentive').on("change", (e) => {
      e.preventDefault();
      this.calculate();
    });

    // Store reference
    this.productElements = {
      tax: this.element.querySelector(this.prefix + 'tax'),
      tradein: this.element.querySelector(this.prefix + 'tradein'),
      has_tax: this.element.querySelector(this.prefix + 'include-taxes'),
      payment_frequency: this.element.querySelector(this.prefix + 'payment-frequency-buttons'),
    };

    // Store reference
    this.financeElements = {
      price: this.element.querySelector(this.prefix + 'price'),
      down: this.element.querySelector(this.prefix + 'finance-down'),
      term: this.element.querySelector(this.prefix + 'finance-term'),
      rate: this.element.querySelector(this.prefix + 'finance-rate'),
      rateDisplay: this.element.querySelector(this.prefix + 'finance-rate-display'),
      balance: this.element.querySelectorAll(this.prefix + 'finance-balance'),
      payment: this.element.querySelector(this.prefix + 'finance-payment'),
      payment_frequency: this.element.querySelector(this.prefix + 'finance-frequency-payment'),
      frequency_multiplier: 1,
    };

    const financeCob = this.element.querySelector(this.prefix + 'finance-cob');

    // check cob here
    if (financeCob) {
      this.financeElements.cob = financeCob;
    }
  

    for (const prop in this.financeElements) {
      if (!this.financeElements[prop]) {
        this.hasFinanceCalculator = false;
      }
    }

    for (const product in this.productElements) {
      // console.log(this.productElements[product].name);
      // console.log(this.productElements[product].value);
    }

    for (const product in this.financeElements) {
      // console.log(this.financeElements[product].name);
      // console.log(this.financeElements[product].value);
    }

    // Store reference
    this.leaseElements = {
      price: this.element.querySelector(this.prefix + 'lease-price'),
      down: this.element.querySelector(this.prefix + 'lease-down'),
      term: this.element.querySelector(this.prefix + 'lease-term'),
      rate: this.element.querySelector(this.prefix + 'lease-rate'),
      rateDisplay: this.element.querySelector(this.prefix + 'lease-rate-display'),
      end: this.element.querySelector(this.prefix + 'lease-end'),
      balance: this.element.querySelectorAll(this.prefix + 'lease-balance'),
      payment: this.element.querySelector(this.prefix + 'lease-payment'),
      payment_frequency: this.element.querySelector(this.prefix + 'lease-frequency-payment'),
      frequency_multiplier: 1,
    };

    const leaseCob = this.element.querySelector(this.prefix + 'lease-cob');

    // check cob lease
    if (leaseCob) {
      this.leaseElements.cob = leaseCob;
    }

    for (const prop in this.leaseElements) {
      if (!this.leaseElements[prop]) {
        this.hasLeaseCalculator = false;
      }
    }
    

    // Handle the "Submit" (calculate) button
    this.element.addEventListener('submit', (event) => {
      event.preventDefault();
      this.calculate();
    });


    this.productElements.payment_frequency.addEventListener('change', (event) => {
      if (event.target.value === 'biweekly') {
        this.financeElements.frequency_multiplier = 1;
        this.leaseElements.frequency_multiplier = 1;
        if (this.financeElements.payment_frequency) {
          this.financeElements.payment_frequency.innerHTML = ' / Bi-Weekly';
        }
        if (this.leaseElements.payment_frequency) {
          this.leaseElements.payment_frequency.innerHTML = ' / Bi-Weekly';
        }
      } else if (event.target.value === 'weekly') {
        this.financeElements.frequency_multiplier = 0.5;
        this.leaseElements.frequency_multiplier = 0.5;
        if (this.financeElements.payment_frequency) {
          this.financeElements.payment_frequency.innerHTML = ' / Week';
        }
        if (this.leaseElements.payment_frequency) {
          this.leaseElements.payment_frequency.innerHTML = ' / Week';
        }
      } else {
        this.financeElements.frequency_multiplier = 2;
        this.leaseElements.frequency_multiplier = 2;
        if (this.financeElements.payment_frequency) {
          this.financeElements.payment_frequency.innerHTML = ' / Month';
        }
        if (this.leaseElements.payment_frequency) {
          this.leaseElements.payment_frequency.innerHTML = ' / Month';
        }
      }
      this.calculate(event.target.value);
    });

    this.financeDownDisplay = false;
    this.leaseDownDisplay = false;

    if (this.hasFinanceCalculator) {
      this.financeDownDisplay = this.element.querySelectorAll('.js-summary-down-payment.finance');
    }

    if (this.hasLeaseCalculator) {
      this.leaseDownDisplay = this.element.querySelectorAll('.js-summary-down-payment.lease');
    }

    //added
    if (this.financeElements.down) {
      this.financeElements.down.addEventListener('input', () => {
        let downAmount = this.financeElements.down.value;
        if (this.financeDownDisplay) {
          this.financeDownDisplay.forEach((elem) => {
           $(elem).text('- ' + Formatter.price(downAmount, 2));
          })
        }
        this.calculate();
      });
    }
    //added
    if (this.leaseElements.down) {
      this.leaseElements.down.addEventListener('input', () => {
        let downAmount = this.leaseElements.down.value;
        if (this.leaseDownDisplay) {
          this.leaseDownDisplay.forEach((elem) => {
            $(elem).text('- ' + Formatter.price(downAmount, 2));
          })
        }
        this.calculate();
      });
    }

    if (this.financeElements.term && this.financeVariables) {
      this.financeElements.term.addEventListener('change', () => {
        const term = this.financeElements.term.value;

        let financeTerms = this.financeVariables.filter((obj) => {
          return obj.to == term;
        });
        const rate = financeTerms[0].value;

        this.financeElements.rate.value = parseFloat(rate).toFixed(2);
        this.financeElements.rateDisplay.innerHTML = parseFloat(rate).toFixed(2);

        this.calculate();

      });
    }

    if (this.leaseElements.term && this.leaseVariables) {
      this.leaseElements.term.addEventListener('change', () => {
        const term = this.leaseElements.term.value;

        let leaseTerms = this.leaseVariables.filter((obj) => {
          return obj.to == term;
        });

        // get new values for the term

        const residualValue = leaseTerms[0].residual_value;
        const leasePrice = leaseTerms[0].incentive_price;
        const rate = leaseTerms[0].value;

        // updates inputs with the new values for the term
        this.leaseElements.end.value = residualValue;
        this.leaseElements.price.value = leasePrice;

        this.leaseElements.rate.value = parseFloat(rate).toFixed(2);
        this.leaseElements.rateDisplay.innerHTML = parseFloat(rate).toFixed(2);

        this.calculate();

      });
    }
    //end added

    // Init with calculations already run once
    this.calculate();
  }

  /**
   * Update calculators with current values.
   */
  updateCalculators() {

    let tradein = this.productElements.tradein.value
      ? Formatter.number(this.productElements.tradein.value)
      : 0;
    let tax = this.includeTax ? Formatter.number(this.productElements.tax.value) : 0;

    if (this.hasFinanceCalculator) {
      // Update Finance Calculator
      Object.assign(this.finance, {
        price: this.financeElements.price.value
          ? Formatter.number(this.financeElements.price.value) - getTotalIMSTargetedSelected('finance')
          : 0,
        tradein,
        tax,
        down: this.financeElements.down.value
          ? Formatter.number(this.financeElements.down.value)
          : 0,
        term: this.financeElements.term.value
          ? Formatter.integer(this.financeElements.term.value)
          : 0,
        rate: this.financeElements.rate.value
          ? Formatter.number(this.financeElements.rate.value)
          : 0,  
      });
    
    }

    if (this.hasLeaseCalculator) {
      Object.assign(this.lease, {
        price: this.leaseElements.price.value
          ? Formatter.number(this.leaseElements.price.value) - getTotalIMSTargetedSelected('lease')
          : 0,
        tradein,
        tax,
        down: this.leaseElements.down.value ? Formatter.number(this.leaseElements.down.value) : 0,
        term: this.leaseElements.term.value ? Formatter.integer(this.leaseElements.term.value) : 0,
        rate: this.leaseElements.rate.value
          ? Formatter.number(this.leaseElements.rate.value)
          : 0, 
        residual: this.leaseElements.end.value ? Formatter.number(this.leaseElements.end.value) : 0,
      });
    }
  }

  calculate() {
    this.updateCalculators();

    let paymentFrequency = 'biweekly';

    $('.payment-frequency-button').each(function () {
      if ($(this)[0].checked) {
        paymentFrequency = $(this)[0].value;
      }
    });

    if (this.hasPaymentDropdown) {
      paymentFrequency = this.dropdown.querySelector('option:checked').value;
    }

    if (this.hasFinanceCalculator) {
      this.finance.calculate();

      this.financeElements.balance.forEach((elem) => {
        elem.textContent = isFinite(this.finance.balance)
        ? Formatter.price(this.finance.balance, 2)
        : '$--.--';
      })

      let financePaymment = this.finance.payments[paymentFrequency];

      this.financeElements.payment.textContent = isFinite(financePaymment)
        ? Formatter.price(financePaymment) 
        : '$--.--';

      if (this.financeElements.cob) {
        const financeCOBconfig = {
          payment: financePaymment,
          term: this.finance.term,
          frequency: paymentFrequency,
          price: this.finance.balance,
          type: 'finance',
        }
        let financeCOBAmount = getCostOfBorrowing(financeCOBconfig);
        this.financeElements.cob.textContent = Formatter.price( financeCOBAmount, 0);
      }  

    }

    if (this.hasLeaseCalculator) {
      this.lease.calculate();

      this.leaseElements.balance.forEach((elem) => {
        elem.textContent = isFinite(this.lease.balance)
        ? Formatter.price(this.lease.balance, 2)
        : '$--.--';
      })

      let leasePayment = this.lease.payments[paymentFrequency];


      this.leaseElements.payment.textContent = isFinite(leasePayment)
        ? Formatter.price(leasePayment) 
        : '$--.--';

        if (this.leaseElements.cob) {
          const leaseCOBconfig = {
            payment: leasePayment,
            term: this.lease.term,
            frequency: paymentFrequency,
            price: this.lease.balance - this.lease.residual,
            type: 'lease',
          }
          let leaseCOBAmount = getCostOfBorrowing(leaseCOBconfig);
          this.leaseElements.cob.textContent = Formatter.price( leaseCOBAmount, 0);
        }


    }
  }

  printAll(types) {
    if (types.includes('finance')) {
      console.log(this.financeElements);
    }

    if (types.includes('lease')) {
      console.log(this.leaseElements);
    }
  }

}

export default PaymentCalculatorForm;
